import { useState, useCallback } from "react";

export const VIEW_MODES = {
  CARD: "card",
  ACTIVITY: "activity",
  TABLE: "table",
};

const STORAGE_KEY = "unifiedDashboard.viewMode";

/**
 * Hook for managing view preference with localStorage persistence
 */
export function useViewPreference(defaultView = VIEW_MODES.CARD) {
  const [viewMode, setViewModeState] = useState(() => {
    try {
      const saved = localStorage.getItem(STORAGE_KEY);
      if (saved && Object.values(VIEW_MODES).includes(saved)) {
        return saved;
      }
    } catch {
      // localStorage not available
    }
    return defaultView;
  });

  const setViewMode = useCallback((mode) => {
    if (Object.values(VIEW_MODES).includes(mode)) {
      setViewModeState(mode);
      try {
        localStorage.setItem(STORAGE_KEY, mode);
      } catch {
        // localStorage not available
      }
    }
  }, []);

  return [viewMode, setViewMode];
}

export default useViewPreference;
